/*
 * @Author: 张斌
 * @Date: 2024-01-20 15:28:45
 * @LastEditors: 张斌
 * @LastEditTime: 2024-05-24 16:17:38
 */
import { commonRequest } from '@/utils/request'

/** 获取pubKey */
export function getPubKey(params: {
  name: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Login/PubKey',
    params,
  })
}
/** 登录 */
export function login(data: {
  name: string
  pwd: string
  key: string
}) {
  return commonRequest({
    method: 'post',
    url: '/V1/Admin/Login',
    data,
  })
}
/** 获取登录信息 */
export function getLoginInfo(params: {
  name: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Login/LoginInfo',
    params,
  })
}
/** 修改密码 */
export function modifyPassword(data: {
  name: string
  pwd: string
  code: string
}) {
  return commonRequest({
    method: 'put',
    url: '/V1/User/updatePwd',
    data,
  })
}
/** 发送手机验证码 */
export function sendPhoneCode(params: {
  name: string
}) {
  return commonRequest({
    method: 'GET',
    url: '/V1/User/PwdCheckCode',
    params,
  })
}

/** 获取code的 */
export function getWebCode(params: {
  appKey: string,
  accessToken: string,
}) {
  return commonRequest({
    method: 'GET',
    url: '/V1/Platform/getWebCode',
    params,
  })
}
//获取Token
export function codeLogin(data: {
  code: string,
 
}) {
  return commonRequest({
    method: 'POST',
    url: '/V1/Login/codeLogin?code='+data.code,
    data,
  })
}
